// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchMenu":"lX","selections":"mX","pillsDesktopSearchMenu":"nX"};